var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initProductCards = /* @__PURE__ */ __name(($el, productHandle) => {
  const product = utils.JSONParse(document.querySelector(`[data-product-data="${productHandle}"]`)?.innerHTML);
  const state = window.Alpine.reactive({
    product,
    upsell_items: /* @__PURE__ */ new Map()
  });
  const setUpsellItem = /* @__PURE__ */ __name((handle, item) => {
    if (!handle) return;
    state.upsell_items.set(handle, item);
  }, "setUpsellItem");
  const deleteUpsellItem = /* @__PURE__ */ __name((handle) => {
    if (!handle) return;
    state.upsell_items.delete(handle);
  }, "deleteUpsellItem");
  const clearUpsellItems = /* @__PURE__ */ __name(() => {
    state.upsell_items.clear();
  }, "clearUpsellItems");
  const getUpsellTotals = /* @__PURE__ */ __name(() => {
    let total = 0;
    let compareAtTotal = 0;
    let count = 0;
    for (const item of state.upsell_items.values()) {
      count += 1;
      const qty = Number(item.quantity ?? 1);
      total += (Number(item.price) || 0) * qty;
      compareAtTotal += (Number(item.compare_at_price) || 0) * qty;
    }
    return { total, compareAtTotal, count };
  }, "getUpsellTotals");
  const addUpsellsToCart = /* @__PURE__ */ __name(async () => {
    if (!state.upsell_items.size) return;
    const items = Array.from(state.upsell_items.values()).map((it) => ({
      id: Number(it.id),
      quantity: Number(it.quantity ?? 1),
      properties: it.properties ?? {},
      ...it.selling_plan ? { selling_plan: Number(it.selling_plan) } : {}
    }));
    const data = await _cart.add({
      items
    });
    if (!data.cart_error) {
      _stores.modal.setId("modal--cart-drawer");
      _stores.productDrawer.show = false;
      _stores.quickView.show = false;
    }
  }, "addUpsellsToCart");
  const renderProductCards = /* @__PURE__ */ __name(async (element, primary_source, secondary_source, hide_if_empty, product_class, desktop_display_limit, mobile_display_limit) => {
    const limit = Math.max(desktop_display_limit, mobile_display_limit);
    const fallback_products = utils.JSONParse(
      element.getAttribute("data-fallback-products")
    );
    const products = [];
    switch (primary_source) {
      case "complementary": {
        state.product?.complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        state.product?.related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (window?._recent_products ?? [])?.map(
            ([handle, product_id]) => _product.getHydratedProductData(handle, product_id)
          )
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    switch (secondary_source) {
      case "complementary": {
        state.product?.complementary_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "related": {
        state.product?.related_products?.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "recently_viewed": {
        const recent_products = await Promise.all(
          (window?._recent_products ?? []).map(
            ([handle, product_id]) => _product.getHydratedProductData(handle, product_id)
          )
        );
        recent_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
      case "manual": {
        fallback_products.forEach((prod) => {
          products.push(prod);
        });
        break;
      }
    }
    const controlProducts = products?.filter((prod) => prod && prod.id !== state.product.id)?.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i) ?? [];
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        $el.closest(`.shopify-section`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "container":
        $el.closest(`[data-style-id]:not([data-style-id="${$el.getAttribute("data-style-id")}"])`)?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
      case "block":
        $el?.classList.toggle("!hidden", controlProducts?.length === 0);
        break;
    }
    const renderProducts = controlProducts?.filter(
      (prod, index) => prod.handle !== element.children?.[index]?.getAttribute("data-product-handle")
    );
    if (!renderProducts.length) {
      return;
    }
    element.innerHTML = "";
    controlProducts.slice(0, limit).forEach((prod, i, arr) => {
      const node = document.querySelector(`[data-product-card='${product_class}']`)?.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute(
          "class",
          `shrink-0 max-w-full w-full ${i > desktop_display_limit ? "mobile-only" : i > mobile_display_limit ? "desktop-tablet-only" : ""}`
        );
        node?.removeAttribute(`data-product-card`);
        node?.setAttribute("data-product-handle", prod.handle);
        node?.setAttribute("data-product-id", `${prod.id}`);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        element.appendChild(div);
      }
    });
  }, "renderProductCards");
  _product.getHydratedProductData(product?.handle, product?.id).then((res) => {
    state.product = state.product?.handle === res?.handle ? res : state.product;
  });
  return {
    product_cards: {
      state,
      renderProductCards,
      setUpsellItem,
      deleteUpsellItem,
      clearUpsellItems,
      getUpsellTotals,
      addUpsellsToCart
    }
  };
}, "initProductCards");
window._sections["initProductCards"] = initProductCards;
